import { Link } from 'react-router-dom';
import './AuthLanding.css';

export default function AuthLanding() {
  return (
    <div className="auth-landing">
      <div className="auth-landing-content">
        <div className="auth-logo">
          <h1>TomorrowDungeons</h1>
          <p className="tagline">Explore unlimited worlds. Can you conquer them all?</p>
        </div>

        <div className="auth-buttons">
          <Link to="/login" className="btn btn-primary btn-lg">
            Sign In
          </Link>
          <Link to="/register" className="btn btn-secondary btn-lg">
            Create Account
          </Link>
        </div>

        <div className="auth-features">
          <div className="feature">
            <span className="feature-icon">⚔️</span>
            <span>Create Custom Characters</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🗺️</span>
            <span>Explore Dynamic Worlds</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🎲</span>
            <span>Classic RPG Mechanics</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🤖</span>
            <span>AI Dungeon Master</span>
          </div>
        </div>
      </div>
    </div>
  );
}
